import React from 'react';
import '../CSS/Profile/DarrelColsonProfile.css';

const DarrelColsonProfile: React.FC = () => {
  const imagePath = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Team Page/Our Team/darrel-d-colson-image.png`;
  const linkedInIcon = `${process.env.PUBLIC_URL || ''}/assets/Web Version/Icons/linkedin-blue-icon.svg`;

  return (
    <div className="profile-page">
      <div className="profile-header">
        <div className="profile-picture-container">
          <img 
            src={imagePath}
            alt="Darrel D. Colson"
            className="profile-picture"
          />
        </div>
      </div>
      <div className="profile-content">
        <h1 className="profile-name">Darrel D. Colson, PhD</h1>
        <div className="profile-title-container">
          <p className="profile-title">Senior Consultant</p>
          <a href="https://www.linkedin.com/in/darrel-colson-43201b122/" target="_blank" rel="noopener noreferrer">
            <img 
              src={linkedInIcon}
              alt="LinkedIn"
              className="profile-linkedin-icon"
            />
          </a>
        </div>
        <div className="profile-desc">
          <p>
            <strong>Darrel Colson, Ph.D.</strong> joined Myers McRae as a Senior Consultant in 2023. He retired as President of Wartburg College in 2022 after 13 years of service, highlighting his extensive leadership experience in higher education, knowledge of expanding academic programs and growing enrollment, and a successful fundraising record.
          </p>
          <p>
            As the 17th president of Wartburg College, which he joined in July 2009, Dr. Colson implemented a transformative strategic plan, raising over $89 million, including nearly $34 million for scholarships. He established six endowed chairs and professorships, oversaw the construction of the Knief Outdoor Athletics Pavilion, and the renovation of Clinton Hall into the McCoy Living and Learning Center. He announced "Focus on the Future," a constituent engagement initiative aimed at increasing faculty, academic opportunities in engineering, community partnerships, and support for at-risk students.
          </p>
          <p>
            Prior to Wartburg, Dr. Colson served as Provost and Dean of the College at Centenary College of Louisiana. He held teaching positions at Western Carolina University (Cullowhee, N.C.) and served on the founding faculty of Louisiana Scholars' College at Northwestern State University (Natchitoches, La.). He also held the Fletcher Jones Chair of Great Books at Pepperdine University (Malibu, Calif.) before becoming a professor of philosophy at Centenary College in 2002.
          </p>
          <p>
            Dr. Colson earned a B.A. degree in philosophy from LSU and a Ph.D. in philosophy from Vanderbilt University. He has served on numerous local, regional, and national boards in higher education, economic development, and healthcare, including the Greater Cedar Valley Alliance; Allen Health System; Allen College; Iowa Intercollegiate Athletic Association; NetVUE Advisory Council; Council of Independent Colleges; the Iowa Association of Independent Colleges and Universities (IAICU), including its Government Relations Committee; and the Network of ELCA Colleges and Universities (NECU).
          </p>
        </div>
      </div>
    </div>
  );
};

export default DarrelColsonProfile;

